<template>
  <div>

    <Form ref="formUnitWithdraw" :model="form" :rules="rules" :label-width="165">
      <Row :gutter="16">

        <Col span="12">
        <FormItem label="上传申请人身份证人像面" prop="applicantIDCardFrontGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <div>
                <Upload type="drag" class="uploadImage" :max-size="5120" :on-exceeded-size="handleMaxSize" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantIDCardFrontGuidProgress')"
                  :show-upload-list="false" :accept="accept" :format="format" :data="{ readIdInfo: true }" :on-success="
                    (response, file, fileList) =>
                     {$refs['applicantIDCardFrontGuidProgress'].updateShow(false)
        $refs['applicantIDCardFrontGuidProgressUpload'].style.display = 'block'; handleSuccess(
                        response,
                        file,
                        fileList,
                        'applicantIDCardFrontGuid',false,'idCard',[{name:'applicantName'},{idCard:'applicantIDCardNo'}]
                      )}
                  " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                  <div class="uploadBg">
                    <span ref="applicantIDCardFrontGuidProgressUpload">
                      <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                      <div class="upload_btn">
                        <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                      </div>
                      <div class="upload_btn" @click.stop="openQrCodeUpload('applicantIDCardFrontGuid',false,'idCard',[{name:'applicantName'},{idCard:'applicantIDCardNo'}])">
                        <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                      </div>
                    </span>
                    <progress-bar ref="applicantIDCardFrontGuidProgress"></progress-bar>
                  </div>
                </Upload>

              </div>
              <!-- 已上传图片 -->
              <div class="fileList" v-if="form.applicantIDCardFrontGuid">
                <span class="pos">
                  <img class="img uploadImage" :src="
                        $baseURL +
                        '/file/cover/' +
                        form.applicantIDCardFrontGuid
                      " />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantIDCardFrontGuid)" type="ios-eye" />
                    <Icon size="26" class="ico" color="#ffffff" @click="
                          handleRemove(
                            0,
                            form.applicantIDCardFrontGuid,
                            'applicantIDCardFrontGuid'
                          )
                        " type="ios-trash-outline" />
                  </i>
                </span>
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="上传申请人身份证国徽面" prop="applicantIDCardBackGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <Upload multiple type="drag" ref="applicantIDCardBackGuid" :data="{readIdbackAfterUploaded: true}" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantIDCardBackGuidProgress')"
                class="uploadImage" :accept="accept" :format="format" :show-upload-list="false" :on-success="
                    (response, file, fileList) =>
                     {$refs['applicantIDCardBackGuidProgress'].updateShow(false)
        $refs['applicantIDCardBackGuidProgressUpload'].style.display = 'block'; handleSuccess(
                        response,
                        file,
                        fileList,
                        'applicantIDCardBackGuid',false,'idcard_back'
                      )}
                  " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                <div class="uploadBg">
                  <span ref="applicantIDCardBackGuidProgressUpload">
                    <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                    <div class="upload_btn">
                      <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                    </div>
                    <div class="upload_btn" @click.stop="openQrCodeUpload('applicantIDCardBackGuid',false,'idcard_back')">
                      <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                    </div>
                  </span>
                  <progress-bar ref="applicantIDCardBackGuidProgress"></progress-bar>
                </div>
              </Upload>
              <!-- 已上传图片 -->
              <div class="fileList" v-if="form.applicantIDCardBackGuid">
                <span class="pos">
                  <img class="img uploadImage" :src="
                        $baseURL + '/file/cover/' + form.applicantIDCardBackGuid
                      " />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantIDCardBackGuid)" type="ios-eye" />
                    <Icon size="26" class="ico" color="#ffffff" @click="
                          handleRemove(
                            0,
                            form.applicantIDCardBackGuid,
                            'applicantIDCardBackGuid'
                          )
                        " type="ios-trash-outline" />
                  </i>
                </span>
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="申请人姓名" prop="applicantName">
          <Input v-model.trim="form.applicantName" disabled :maxlength="20" placeholder="上传身份证人像面自动识别"></Input>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="申请人身份证号" prop="applicantIDCardNo">
          <Input v-model.trim="form.applicantIDCardNo" disabled :maxlength="20" placeholder="上传身份证人像面自动识别"></Input>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem label="申请人联系方式" prop="applicantPhone">
          <Input v-model.trim="form.applicantPhone" :maxlength="40" placeholder="请填写"></Input>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem label="上传申请人居住证正面" prop="applicantResidencePermitFrontGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <Upload multiple type="drag" class="uploadImage" :max-size="5120" :on-exceeded-size="handleMaxSize" :accept="accept" :format="format" :data="{readResidencePermit:true,}"
                :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantResidencePermitFrontGuidProgress')" :show-upload-list="false" :on-success="
                    (response, file, fileList) =>
                    {  $refs['applicantResidencePermitFrontGuidProgress'].updateShow(false)
        $refs['applicantResidencePermitFrontGuidProgressUpload'].style.display = 'block';handleSuccess(
                        response,
                        file,
                        fileList,
                        'applicantResidencePermitFrontGuid',false,'residencePermit',[{residencePermitExpiryDate:'applicantResidencePermitExpiryDate'}]
                      )}
                  " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                <div class="uploadBg">
                  <span ref="applicantResidencePermitFrontGuidProgressUpload">
                    <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                    <div class="upload_btn">
                      <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                    </div>
                    <div class="upload_btn" @click.stop="openQrCodeUpload('applicantResidencePermitFrontGuid',false,'residencePermit',[{residencePermitExpiryDate:'applicantResidencePermitExpiryDate'}])">
                      <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                    </div>
                  </span>
                  <progress-bar ref="applicantResidencePermitFrontGuidProgress"></progress-bar>
                </div>
              </Upload>
              <!-- 已上传图片 -->
              <div class="fileList" v-if="form.applicantResidencePermitFrontGuid">
                <span class="pos">
                  <img class="img uploadImage" :src="
                        $baseURL +
                        '/file/cover/' +
                        form.applicantResidencePermitFrontGuid
                      " />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantResidencePermitFrontGuid)" type="ios-eye" />
                    <Icon size="26" class="ico" color="#ffffff" @click="
                          handleRemove(
                            0,
                            form.applicantResidencePermitFrontGuid,
                            'applicantResidencePermitFrontGuid'
                          )
                        " type="ios-trash-outline" />
                  </i>
                </span>
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
        <!-- <Col span="12">
        <FormItem label="上传申请人居住证反面" prop="applicantResidencePermitBackGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <Upload multiple type="drag" class="uploadImage" :accept="accept" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantResidencePermitBackGuidProgress')" :format="format"
                :show-upload-list="false" :on-success="
                    (response, file, fileList) =>
                      {$refs['applicantResidencePermitBackGuidProgress'].updateShow(false)
        $refs['applicantResidencePermitBackGuidProgressUpload'].style.display = 'block';handleSuccess(
                        response,
                        file,
                        fileList,
                        'applicantResidencePermitBackGuid'
                      )}
                  " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                <div class="uploadBg">
                  <span ref="applicantResidencePermitBackGuidProgressUpload">
                    <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                    <div class="upload_btn">
                      <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                    </div>
                    <div class="upload_btn" @click.stop="openQrCodeUpload('applicantResidencePermitBackGuid')">
                      <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                    </div>
                  </span>
                  <progress-bar ref="applicantResidencePermitBackGuidProgress"></progress-bar>
                </div>
              </Upload>
              <div class="fileList" v-if="form.applicantResidencePermitBackGuid">
                <span class="pos">
                  <img class="img uploadImage" :src="
                        $baseURL +
                        '/file/cover/' +
                        form.applicantResidencePermitBackGuid
                      " />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantResidencePermitBackGuid)" type="ios-eye" />
                    <Icon size="26" class="ico" color="#ffffff" @click="
                          handleRemove(
                            0,
                            form.applicantResidencePermitBackGuid,
                            'applicantResidencePermitBackGuid'
                          )
                        " type="ios-trash-outline" />
                  </i>
                </span>
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col> -->
        <Col span="12">
        <FormItem label="居住证有效期" prop="applicantResidencePermitExpiryDate">
          <DatePicker type="date" disabled :editable="false" v-model.trim="form.applicantResidencePermitExpiryDate" placeholder="请选择" style="width: 100%" />
        </FormItem>
        </Col>
        <Col span="12">

        </Col>
        <Col span="24">
        <FormItem label="撤回原因" prop="wiithdrawReason">
          <Input v-model="form.wiithdrawReason" maxlength="200" show-word-limit type="textarea" placeholder="请输入"></Input>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="其他材料" prop="otherFileGuidList">
          <Upload ref="otherFileGuidList" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :show-upload-list="false" :default-file-list="form.otherFileGuidListPreview" style="flex:1;" :on-preview="handlePreview"
            :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'otherFileGuidList',true)"
            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'otherFileGuidList',true)" :on-format-error="handleFormatError">
            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
            <Button icon="ios-camera" @click.stop="openQrCodeUpload('otherFileGuidList',true)">手机拍照上传</Button>
          </Upload>
          <div class="_linkdel" v-for="file in form.otherFileGuidListPreview" :key="file.guid">
            <div class="fileCentent" @click="handlePreview(file)">
              <Icon :type="file.name | fileType" />
              {{file.name?file.name:file.fileName}}
            </div>
            <div class="fileDel">
              <Icon type="md-close" @click="handleRemove(file, null, 'otherFileGuidList',true)" />
            </div>
          </div>
        </FormItem>
        </Col>
      </Row>
      <div class="bom_btn">
        <div>
          <Button @click="next(0)">上一步</Button>
          <Button type="primary" @click="submitAccept('formUnitWithdraw')">提交</Button>
        </div>
      </div>
    </Form>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>
<script>
export default {
  props: { form: { type: Object } },
  data() {
    return {
      current: {},
      loading: false,
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      appInfoDataType: this.$store.state.appInfoDataType,
      //   form: { id: 'ywlsh_12356789', kh: '新开户', sfzzm: [] },
      uploadData: {},
      ywlbList: [
        {
          name: '积分新办：年龄+教育背景（高于或等于本科学士）+社保年限',
          value: '积分新办：年龄+教育背景（高于或等于本科学士）+社保年限',
        },
      ],
      rules: {
        applicantIDCardNo: [{ required: true, message: '请输入' }],
        applicantPhone: [
          { required: true, message: '请输入', trigger: 'change' },
          {
            pattern: /^[0-9]+$/,
            message: '请输入正确的联系方式',
            trigger: 'change',
          },
        ],
        applicantName: [{ required: true, message: '请输入' }],
        wiithdrawReason: [{ required: true, message: '请输入' }],
        applicantIDCardFrontGuid: [{ required: true, message: '请上传' }],
        applicantIDCardBackGuid: [{ required: true, message: '请上传' }],
        applicantResidencePermitFrontGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        applicantResidencePermitBackGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        applicantResidencePermitExpiryDate: [
          {
            required: true,
            message: '请选择',
            type: 'date',
            trigger: 'change',
          },
        ],
      },
      clList: ['rl', 'dw', 'yy', 'sh', 'rl'],
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
      uniPersonalList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  methods: {
    //上一步
    next(val) {
      this.$emit('next', val)
    },
    //提交
    submitAccept(name) {
      this.$refs[name].validate((valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        //有提交路径才执行
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确认提交申请？</p>',
          okText: '是',
          cancelText: '否',
          onOk: async () => {
            // 是 直接提交
            this.submit()
          },
          onCancel: () => {},
        })
      })
    },

    async submit() {
      this.loading = true
      let params = {
        guid: '',
        enterpriseId: 0,
        enterpriseName: '',
        enterpriseCode: '',
        personnelId: 0,
        personnelName: '',
        personnelIDCardNo: '',
        personnelPhone: '',
        applicantName: '',
        applicantIDCardNo: '',
        applicantPhone: '',
        applicantIDCardFrontGuid: '',
        applicantIDCardBackGuid: '',
        applicantResidencePermitFrontGuid: '',
        applicantResidencePermitBackGuid: '',
        applicantResidencePermitExpiryDate: '',
        wiithdrawReason: '',
        otherFileGuids: '',
        otherFileGuidList: [],
      }
      for (let key in params) {
        if (key in this.form) {
          params[key] = this.form[key]
        }
      }
      try {
        let data = await this.$Ajax.post(
          '/api/services/app/OtherApplicationApi/SaveUnitWithdrawalInfo',
          params
        )
        this.loading = false
        if (data.data.success) {
          this.$Message.success({
            content: '提交成功',
            background: true,
            duration: 6,
          })
        }
        this.$emit('setResult', data.data.result)
        this.next(100)
      } catch (error) {
        this.loading = false
      }
    },
    //预览
    handleView(guid) {
      this.$emit('handleView', guid)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
    //文件大小超出
    handleMaxSize(file) {
      this.$emit('handleMaxSize', file)
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(response, file, fileList, property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit(
        'handleSuccess',
        response,
        file,
        fileList,
        property,
        isArray,
        isReadInfo,
        readIdInfoAfterToView
      )
      this.$refs['formUnitWithdraw'].validateField(property)
    },
    openQrCodeUpload(property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit('openQrCodeUpload', property, isArray, isReadInfo, readIdInfoAfterToView)
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //
    updateProgress(event, file, fileList, name) {
      // this.percent = fileInfo.percent * 0.01
      this.$refs[name + 'Upload'].style.display = 'none'
      this.$refs[name].updateShow(true)
      this.$refs[name].updateProgress(Math.round(event.percent)) //=fileInfo.percent * 0.01

      this.$refs[name + 'Upload'].show = event.percent == 100
      // if (event.percent == 100) {
      //   this.$refs[name].updateShow(false)
      //   this.$refs[name + 'Upload'].style.display = 'block'
      // }
    },
  },
}
</script>
